import { useSelector, connect } from "react-redux";
import { DealerPartViewDashboard } from "pages/partview/dealer-partview-dashboard/DealerPartView.Dashboard.page";
import PartViewDashboardState from "pages/partview/redux/PartViewDashboardState";
import PartViewDashboardStatePG from "pages/partview/redux/PartViewDashboardStatePG";
import DealerPartViewSearchBarState from "pages/partview/redux/DealerPartViewSearchBarState";
import DealerPartViewSearchBarStatePG from "pages/partview/redux/DealerPartViewSearchBarStatePG";
import { getAuthorization } from "modules/auth/AuthorizationSelectors";
import { OrganizationType } from "shared/constants/organization.const";
import { getPast24Hrs } from "pages/partview/utils/dashboard.utils";

function mapStateToProps(state, props) {
  const auth = getAuthorization(state);
  const isPostGresFeatureEnabled = props.isPostGresFeatureEnabled;
  const searchBarState = isPostGresFeatureEnabled
    ? DealerPartViewSearchBarStatePG
    : DealerPartViewSearchBarState;
  const dashboardState = isPostGresFeatureEnabled
    ? PartViewDashboardStatePG
    : PartViewDashboardState;

  //postgres
  const {
    getActiveAndExceptionCountsRequestDataPG,
    getEtaPackagesCountsRequestDataPG,
  } = PartViewDashboardStatePG.selectors;

  const {
    getExceptionsListRequestData,

    //common selectors
    getWatchedTableIsLoading,
    getWatchedTableResults,
    getWatchedTablePageIndex,
    getWatchedTablePageSize,
    getWatchedTablePageCount,
  } = PartViewDashboardState.selectors;

  return {
    selectedFvOrgId: searchBarState.selectors.getSelectedFvOrgId(state),
    activeAndExceptionCountsRequestData:
      getActiveAndExceptionCountsRequestDataPG(state),
    exceptionsListRequestData: getExceptionsListRequestData(state),
    exceptionOrPackageStatusCountsRequestData:
      dashboardState.selectors.getExceptionCountsRequestData(state),

    watchedTableIsLoading: getWatchedTableIsLoading(state),
    watchedTableResults: getWatchedTableResults(state),
    watchedTablePageIndex: getWatchedTablePageIndex(state),
    watchedTablePageSize: getWatchedTablePageSize(state),
    watchedTablePageCount: getWatchedTablePageCount(state),
    isDealerOrg: auth.hasOrganizationTypes([OrganizationType.DEALER]),
    etaPackagesCountsRequestData: getEtaPackagesCountsRequestDataPG(state),
    includeAPU: getAuthorization(state).validateEntitySystemConfigValue([
      { key: "AVAILABLE_FOR_PICKUP", value: "true" },
    ]),
    isPostGresFeatureEnabled,
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  const isPostGresFeatureEnabled = ownProps.isPostGresFeatureEnabled;
  const searchBarState = isPostGresFeatureEnabled
    ? DealerPartViewSearchBarStatePG
    : DealerPartViewSearchBarState;

  const {
    fetchExceptionOrPackageStatusCountsPG,
    fetchActiveAndExceptionCountsPG,
    fetchEtaPackagesCountsPG,
  } = PartViewDashboardStatePG.actionCreators;

  // Sets past 24 hrs date range for delivered packages count to keep constant between dashboard and search
  const past24hrs = getPast24Hrs();

  const {
    fetchExceptionOrPackageStatusCounts,

    //common actionCreator
    fetchExceptionList,
    fetchWatchedPackages,
    setWatchedTablePageIndex,
  } = PartViewDashboardState.actionCreators;

  return {
    //common actionCreator
    fetchExceptionList: () => {
      dispatch(fetchExceptionList());
    },
    fetchExceptionOrPackageStatusCounts: (fvOrgId, isDealerOrg, includeAPU) => {
      if (isPostGresFeatureEnabled) {
        dispatch(
          fetchExceptionOrPackageStatusCountsPG(
            fvOrgId,
            isDealerOrg,
            includeAPU,
          ),
        );
      } else {
        dispatch(
          fetchExceptionOrPackageStatusCounts(
            fvOrgId,
            past24hrs.toDate,
            past24hrs.fromDate,
          ),
        );
      }
    },

    fetchActiveAndExceptionCountsPG: (fvOrgId, includeAPU) =>
      dispatch(fetchActiveAndExceptionCountsPG(fvOrgId, includeAPU)),
    fetchEtaPackagesCountsPG: (fvOrgId) =>
      dispatch(fetchEtaPackagesCountsPG(fvOrgId)),

    //common actionCreator
    fetchWatchedPackages: (hasDealerView, fvOrgId) =>
      dispatch(fetchWatchedPackages(hasDealerView, fvOrgId)),
    setWatchedTablePageIndex: (index) =>
      dispatch(setWatchedTablePageIndex(index)),

    searchEntities: (solutionId) =>
      dispatch(searchBarState.actionCreators.searchEntities(solutionId)),
    setSearchFilter: (key, value) =>
      dispatch(searchBarState.actionCreators.setSearchFilter(key, value)),
    clearSearchFilters: () =>
      dispatch(searchBarState.actionCreators.clearSearchFilters()),
    resetSearchBar: () =>
      dispatch(searchBarState.actionCreators.resetSearchBar()),
    resetSavedSearch: () =>
      dispatch(searchBarState.actionCreators.resetSavedSearch()),
    past24hrs: past24hrs,
  };
}

const DashboardPageContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealerPartViewDashboard);

export default function DealerPartViewDashboardPageContainer() {
  const isPostGresFeatureEnabled = false;
  return (
    <DashboardPageContainer
      isPostGresFeatureEnabled={isPostGresFeatureEnabled}
    />
  );
}
